// extracted by mini-css-extract-plugin
module.exports = {"paragraphShortMargin":"ReviewInfo_paragraphShortMargin__3Fgqb","paragraphLargeMargin":"ReviewInfo_paragraphLargeMargin__1lXZZ"};